exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tour .title{padding-bottom:10px}.tour-link{margin-top:2px}", ""]);

// exports
